<template>
    <div class="request-guide-modal">
        <ModalPattern class="absolute left-0 top-0 z-[0]" />

        <div class="header">
            <div class="icon-container">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.75 12C15.75 12.1989 15.671 12.3897 15.5303 12.5303C15.3897 12.671 15.1989 12.75 15 12.75H9C8.80109 12.75 8.61032 12.671 8.46967 12.5303C8.32902 12.3897 8.25 12.1989 8.25 12C8.25 11.8011 8.32902 11.6103 8.46967 11.4697C8.61032 11.329 8.80109 11.25 9 11.25H15C15.1989 11.25 15.3897 11.329 15.5303 11.4697C15.671 11.6103 15.75 11.8011 15.75 12ZM15 14.25H9C8.80109 14.25 8.61032 14.329 8.46967 14.4697C8.32902 14.6103 8.25 14.8011 8.25 15C8.25 15.1989 8.32902 15.3897 8.46967 15.5303C8.61032 15.671 8.80109 15.75 9 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25ZM20.25 3.75V18.75C20.25 19.5456 19.9339 20.3087 19.3713 20.8713C18.8087 21.4339 18.0456 21.75 17.25 21.75H6.75C5.95435 21.75 5.19129 21.4339 4.62868 20.8713C4.06607 20.3087 3.75 19.5456 3.75 18.75V3.75C3.75 3.55109 3.82902 3.36032 3.96967 3.21967C4.11032 3.07902 4.30109 3 4.5 3H6.75V2.25C6.75 2.05109 6.82902 1.86032 6.96967 1.71967C7.11032 1.57902 7.30109 1.5 7.5 1.5C7.69891 1.5 7.88968 1.57902 8.03033 1.71967C8.17098 1.86032 8.25 2.05109 8.25 2.25V3H11.25V2.25C11.25 2.05109 11.329 1.86032 11.4697 1.71967C11.6103 1.57902 11.8011 1.5 12 1.5C12.1989 1.5 12.3897 1.57902 12.5303 1.71967C12.671 1.86032 12.75 2.05109 12.75 2.25V3H15.75V2.25C15.75 2.05109 15.829 1.86032 15.9697 1.71967C16.1103 1.57902 16.3011 1.5 16.5 1.5C16.6989 1.5 16.8897 1.57902 17.0303 1.71967C17.171 1.86032 17.25 2.05109 17.25 2.25V3H19.5C19.6989 3 19.8897 3.07902 20.0303 3.21967C20.171 3.36032 20.25 3.55109 20.25 3.75ZM18.75 4.5H17.25V5.25C17.25 5.44891 17.171 5.63968 17.0303 5.78033C16.8897 5.92098 16.6989 6 16.5 6C16.3011 6 16.1103 5.92098 15.9697 5.78033C15.829 5.63968 15.75 5.44891 15.75 5.25V4.5H12.75V5.25C12.75 5.44891 12.671 5.63968 12.5303 5.78033C12.3897 5.92098 12.1989 6 12 6C11.8011 6 11.6103 5.92098 11.4697 5.78033C11.329 5.63968 11.25 5.44891 11.25 5.25V4.5H8.25V5.25C8.25 5.44891 8.17098 5.63968 8.03033 5.78033C7.88968 5.92098 7.69891 6 7.5 6C7.30109 6 7.11032 5.92098 6.96967 5.78033C6.82902 5.63968 6.75 5.44891 6.75 5.25V4.5H5.25V18.75C5.25 19.1478 5.40804 19.5294 5.68934 19.8107C5.97064 20.092 6.35218 20.25 6.75 20.25H17.25C17.6478 20.25 18.0294 20.092 18.3107 19.8107C18.592 19.5294 18.75 19.1478 18.75 18.75V4.5Z" fill="#09090B"/>
                </svg>
            </div>
            <div class="title">
                <h4>Request Deletion Guide</h4>
                <p>placeholder text</p>
            </div>

            <div class="close-icon">
                <svg @click="closeDialog" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#A4A7AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        </div>

        <div class="input-container">
            <label>Information</label>

            <prime-text-area rows="8" placeholder="Enter any information you have here..." v-model="info" />
        </div>

        <div class="actions-section">
            <prime-button variant="secondary" @click="closeDialog" class="p-btn-root_secondary">Cancel</prime-button>
            <prime-button label="Submit" @click="submit" :disabled="info === ''" />
        </div>
    </div>
</template>

<script setup lang="ts">
import ModalPattern from '~/assets/images/illustrations/modal-pattern.svg';
import { ModalNames } from '~/types/modals';

const info = ref('');
const { showSuccess, showError, showWarning } = useGlobalToast();
const dialogRef = getDialogRef(ModalNames.REQUEST_NEW_COMPANY);
const closeDialog = () => {
    dialogRef.value.close();
};

const submit = () => {
    showSuccess('Success', 'Request Deletion Guide Sent successfully');
    closeDialog();
};

</script>

<style lang="scss" scoped>
.close-icon {
    @apply relative ml-auto right-0 top-0 cursor-pointer p-1 rounded-full z-10 cursor-pointer ;
}
.header {
    @apply relative z-10 flex flex-row gap-4 justify-start ;

    .icon-container {
        @apply flex w-12 h-12 p-3 justify-center items-center rounded-lg border border-gray-200 bg-white shadow-cardshadow;
    }
    .title {
        h4 {
            @apply text-gray-900 text-lg font-semibold leading-7 ;
        }

        p {
            @apply text-gray-600 text-sm font-normal leading-5 ;
        }
    }
}
.request-guide-modal {
    @apply p-6 sm:max-w-xl sm:w-[440px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto relative;
}
.input-container {
    @apply flex flex-col gap-1 mt-5 relative z-10 ;
    label {
        @apply text-gray-700 text-sm font-medium leading-5 ;
    }
}
.actions-section {
    @apply flex gap-3 mt-8 justify-end relative z-10 ;
}
</style>